import ajax from './fetch.js'
export default {
  /**
   *  [邛海泸山景区入园统计--获取游客种类]
   * */
  getGuestTypeList (params) {
    return ajax({
      url: 'common/getGuestType',
      type: 'get',
      params: Object.assign({...params})
    })
  },
  /**
   *  [邛海泸山景区入园统计--通过手机号查询今日是否入园]
   * */
  findInfoByPhone (params) {
    return ajax({
      url: 'sceneryTourist/findInfoByPhone',
      type: 'get',
      loading: false,
      params: Object.assign({...params})
    })
  },
  /**
   *  [邛海泸山景区入园统计--提交]
   * */
  saveSceneryTourist (params) {
    return ajax({
      url: 'sceneryTourist/saveSceneryTourist',
      type: 'get',
      params: Object.assign({...params})
    })
  },
  /**
   *  [邛海泸山景区入园统计--提交(针对特殊游客入园登记提交)]
   * */
  saveSceneryTouristGh (params) {
    return ajax({
      url: 'sceneryTourist/saveSceneryTouristQh',
      type: 'get',
      params: Object.assign({...params})
    })
  },
  /**
   * [微信签名]
   * @returns
   */
  getSign () {
    return ajax({
      url: 'weChat/getSignature',
      type: 'get',
      params: {
        url: document.URL
      },
      loading: false
    })
  },
  /**
   * [下载多媒体地址]
   * @returns
   */
  sGetMediaUrl (params) {
    return ajax({
      url: 'alarm/getWechatMediaUrl',
      type: 'get',
      params: Object.assign({...params})
    })
  }
}



// WEBPACK FOOTER //
// ./src/service/sign.js